import React from 'react';
import { WrapperFlex, Button } from '@unimed-fesp/components';

import { ContentText } from '../PartsModalParametrizacao/styles';

const BodyAlterarStatusRpa = ({ qtdListas }) => {
  if (qtdListas <= 0)
    throw new Error('A propriedade "qtdListas" deve ser maior que 0');

  const SINGULAR = qtdListas === 1;

  return (
    <ContentText>
      {SINGULAR
        ? 'Deseja alterar o status da lista de RPA?'
        : 'Deseja alterar o status das listas de RPA?'}
    </ContentText>
  );
};

const FooterAlterarStatusRpa = ({ closeModal, onClickOk }) => {
  return (
    <WrapperFlex justifySpaceAround minWidth={250}>
      <Button tipo="secondary" onClick={closeModal} width={100} justifyCenter>
        não
      </Button>
      <Button onClick={onClickOk} width={100} justifyCenter>
        sim
      </Button>
    </WrapperFlex>
  );
};

export default { BodyAlterarStatusRpa, FooterAlterarStatusRpa };
